module.exports = "/fonts/Objectivity-Thin.woff2";